import styled, { css } from 'styled-components';
import { Button } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	z-index: 5;
	display: flex;
	flex-direction: column;
	top: 0;
	left: -2px;
	bottom: 0;
	width: calc(100% + 4px);
	padding: 0 2px;
	background-color: rgba(17, 19, 20, 0.98);
`;

const StyledInputContainer = styled.div`
	margin-top: 20px;
`;

const StyledRegionList = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledNumberContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 30px;
	background-color: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	transition: background-color 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;
	}
`;

const StyledRegionContainer = styled.div`
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	gap: 20px;
	height: 70px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	& > ${Text} {
		font-size: 16px;
		color: #ffffff;
	}

	&:hover {
		${StyledNumberContainer} {
			background-color: #ffffff;

			${Text} {
				color: #000000;
			}
		}
	}
`;

const StyledSelectButton = styled(Button)<{ $selected?: boolean }>`
	padding: 0 10px;
	font-size: 16px;

	${(props) =>
		props.$selected &&
		css`
			background-color: #fabe2c;
			color: #000000;
		`}
`;

export {
	StyledContainer,
	StyledInputContainer,
	StyledNumberContainer,
	StyledRegionContainer,
	StyledRegionList,
	StyledSelectButton,
};
